<div class="w-full flex flex-col gap-2">
  <div class="relative w-full border border-solid border-color-light-shade rounded-[4px] p-3 flex flex-row items-center gap-3">
    <mat-icon class="text-color-primary max-h-4 h-4 max-w-4 w-4 text-[16px]">search</mat-icon>
    <input
      type="text"
      class="text-color-text text-sm font-normal outline-none focus:outline-none active:outline-none border-none w-full"
      [formControl]="searchNameInputControl"
      [placeholder]="placeholder"
    />
    @if (isLoading()) {
      <div class="absolute top-[45px] left-0 w-full h-[3px] rounded-b-[4px] overflow-hidden">
        <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
      </div>
    }
  </div>

  <ul class="w-full flex flex-col list-none p-0 m-0" [@listAnimation]>
    <ng-scrollbar
      #scrollbarRef
      (updated)="onScrollbarUpdate(scrollbarRef)"
      [visibility]="'hover'"
      autoHeightDisabled="false"
      class="w-full max-h-[240px] flex flex-col"
    >
      @if (!searchNameInputControl.value && options().length) {
        <li
          class="cursor-pointer w-full max-w-full overflow-hidden rounded-[4px] px-3 py-[10px] text-color-neutral text-sm truncate hover:bg-[#F1F5FD] transition-all"
          [ngClass]="{ 'bg-[#F1F5FD]': !control.value }"
          (click)="clearControl()"
        >
          {{ allOptionsLabel }}
        </li>
      }

      @if (searchNameInputControl.value && !options().length) {
        <li class="w-full max-w-full px-3 py-[10px] text-color-secondary text-xs text-center">
          {{ noOptionsLabel }}
        </li>
      }

      @for (option of options(); track $index) {
        <li
          class="cursor-pointer w-full rounded-[4px] px-3 py-[10px] text-color-neutral text-sm truncate hover:bg-color-light-shade transition-all"
          [ngClass]="{ 'bg-[#F1F5FD]': isSelected(option) }"
          (click)="selectOption(option)"
        >
          {{ option?.name }}
        </li>
      }
    </ng-scrollbar>
  </ul>
</div>
